// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/holding-position-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/holding-position-procedures/holding-position-procedures.js';
import g1 from '../lessons/air-law/holding-position-procedures/ils-critical-area-protection.js';

mount([g0, g1]);
